import { Navigate, Route, Routes } from 'react-router-dom';
import { PRODUCT_INDEX_ROUTE, STEPS } from './demo/steps';
import { VisitedProvider } from './demo/useVisited';
import StepLayout from './shell/StepLayout';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Overview from './pages/product/Overview';
import './ui/ui.css';

/*
 * Internal build (branch brochure-demo-internal): the live brochure without
 * the sign-up form. Every page opens directly, typed URLs included; /start
 * (the form on the public build) goes Home.
 */
function App() {
  return (
    <VisitedProvider>
      <Routes>
        <Route path="/start" element={<Navigate replace to="/" />} />
        <Route element={<StepLayout />}>
          <Route path="/" element={<Home />} />
          <Route path={PRODUCT_INDEX_ROUTE} element={<Overview />} />
          {STEPS.map(({ n, route, component: Page }) => (
            <Route key={n} path={route} element={<Page />} />
          ))}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </VisitedProvider>
  );
}

export default App;
